import { LANGUAGE, LOCALE } from "@myplant-io/user-management";

export const CLIENT_ID = "LOSD83Q3XIGXJ";
export const MANUALS_KEY = "AI-INNIO_userManual";
export const API_BASE_URL = "/seshat";
export const WS_BASE_URL = "/ws";
export const MYPLANT_URL = "https://myplant.io";
export const SUPPORTED_LANGUAGES = [LANGUAGE.en];
export const SUPPORTED_LOCALES = [LOCALE.enUS, LOCALE.deDE];
